class HomePageSearch extends DrupalBehavior {

  onContent(context) {
    const session_token = crypto.randomUUID();
    var xhr;
    var keywordLengthLast = 0;
    var minChars = 3;
    let skipManualTriggerSearch = false;
    const debugPlease = false;

    const adjustAutocompleteHeight = () => {

      const $autocomplete = $('.summit-autocomplete--show');
      const $contentItems = $autocomplete.find('li');

      if (!$autocomplete.length) {
        console.log('No `.summit-autocomplete` element found.');
        return;
      }


      if (!$autocomplete.hasClass('summit-autocomplete--show')) {
        console.log('summit-autocomplete--show hasn\'t been added yet.');
        return;
      }

      // Adjust height to fill available space. Account for window height AND scrolling
      const distanceScrolled = $(window).scrollTop();
      const autocompleteTop = $autocomplete.offset().top - distanceScrolled;
      const availableSpace =  $(window).height() - autocompleteTop;

      let contentHeight = 0;
      let cssHeight = 'unset';

      $contentItems.each(function () {
        contentHeight += $(this).outerHeight(true);
      });

      const hasScrolling = contentHeight > availableSpace;

      if (hasScrolling) {
        cssHeight = availableSpace - 20 + 'px';
      }

      $autocomplete.css({
        'height': cssHeight,
      });
    };

    const adjustAutocompletePosition = () => {
      // Make a <style> tag with the styles to override.

      // Because: I can't figure out why sometimes autocomplete is being positioned incorrectly by the plugin
      // Can't do inline style because it gets recreated with every keyup and it jumps around

      const searchForm = $('#summit-homepage-search-form');
      const formOffset = searchForm.offset();

      const marginTop = 42;
      const marginLeft = 24;

      if (formOffset) {
          // Get the top and left positions from the document
          const formTop = formOffset.top;
          const formLeft = formOffset.left;
          const autocompleteTop = formTop + marginTop;
          const autocompleteLeft = formLeft + marginLeft;

          const $autocompleteMenu = $('.summit-autocomplete');

          // Create a <style> element with a unique ID
          const styleId = 'autocomplete-position-style';

          // If the style tag already exists, remove it
          $('#' + styleId).remove();

          const styleTag = $('<style>')
              .attr('id', styleId)
              .text(`
                  body:not(.modal-open) .summit-autocomplete {
                      top: ${autocompleteTop}px !important;
                      left: ${autocompleteLeft}px !important;
                  }
              `);

          $('head').append(styleTag);

      } else {
          console.warn('#summit-homepage-search-form offset not found.');
      }
    };


    const adjustAutocomplete = () => {
      let targetExists = false;
      let attempts = 0;
      const maxAttempts = 50;

      const checkForTarget = setInterval(() => {
        if ($('.summit-autocomplete').length) {

          targetExists = true;
          adjustAutocompleteHeight();
          adjustAutocompletePosition();
          clearInterval(checkForTarget);

        } else if (attempts >= maxAttempts) {
          clearInterval(checkForTarget);
        }
        attempts++;
      }, 10);

    }


    const triggerSearch = (inputField, source = 'unknown') => {

      let inputValue = inputField.val();
      let storedSearch = localStorage.getItem('recentSearch');
      let searchTerm = '';


      switch (source) {
        case 'descendingHasKeyword':
          // If deleting characters and have < 3, stick with storedSearch
          searchTerm = storedSearch;
          break;

        case 'descendingNoKeyword':
          // If deleted to no characters, do an empty search to trigger suggestions and clear stored value
          searchTerm = '';
          break;

        case 'FocusOnInput':
          if (inputValue === '') {
            // Input has been focused on after being empty
            if (storedSearch) {
              inputField.val(storedSearch);
              searchTerm = storedSearch;
              keywordLengthLast = searchTerm.length;
              // keyword[0].dispatchEvent(new InputEvent('input'));
            } else {
              // Trigger "Common Search Terms"
              searchTerm = 'X';
            }
          } else {
            searchTerm = inputValue;
          }
          break;

        default:
          searchTerm = inputValue;
          break;
      }

      if (searchTerm) {
        inputField.summitAutocomplete('search', searchTerm);
        if (searchTerm != 'X') {
          $('.summit-homepage-search-form .form-item-keywords .clear-button').removeClass('hidden');
        }
      }

      if (debugPlease) {
        console.group('triggerSearch()');
        console.log('source: ' , source);
        console.log('inputValue: ' , inputValue);
        console.log('storedSearch: ' , storedSearch);
        console.log('searchTerm: ' , searchTerm);
        console.groupEnd();
      }

    };

    const resetAutocompleteMenu = ($inputField) => {
      const $autocompleteMenu = $('.summit-autocomplete');

      $('input.form-text.ui-autocomplete-input').blur();

      if ($autocompleteMenu.length) {
        $autocompleteMenu.empty(); // Empty the menu contents
        $autocompleteMenu.removeClass('summit-autocomplete--show').css('display','none');
        $('body').removeClass('autocomplete-initialized').removeClass('autocomplete--is-showing'); // Clean up the body class
        skipManualTriggerSearch = false;
      }
    };

    const checkClickOutside = (event) => {

      event.stopPropagation();

      // Prevent multiple triggers from bubbling and triggering multiple events
      if (event.handled === true) return;
      event.handled = true;

      const $target = $(event.target);

      let autocompleteIsNotShowing = !$('body').hasClass('autocomplete--is-showing');
      let modalIsOpen = $('body').hasClass('modal-open');
      let clickedOnInput = $target.is('input.form-text.ui-autocomplete-input');
      let allowReset = !(autocompleteIsNotShowing || modalIsOpen || clickedOnInput );

      if (debugPlease) {
        console.group('checkClickOutside()');
        console.log('autocompleteIsNotShowing: ' , autocompleteIsNotShowing);
        console.log('modalIsOpen: ' , modalIsOpen);
        console.log('clickedOnInput: ' , clickedOnInput);
        console.log('allowReset: ' , allowReset);
        console.groupEnd();
      }

      if (allowReset) {
        resetAutocompleteMenu();
      }





    };

    // Initialize FreshpaintGeocoder autocomplete for address field
    const initAddressAutocomplete = () => {
      if (window.FreshpaintGeocoder && typeof window.FreshpaintGeocoder === 'function') {
        const geocoder = new FreshpaintGeocoder();
        const addressInput = document.querySelector('.form-item-address input.form-text');
        if (addressInput && typeof geocoder.autocomplete === 'function') {
          geocoder.autocomplete(addressInput, (result, input) => {
            // Store the selected result for geocoding
            input.selectedResult = result;
          });
          
          // Add class to dropdown for homepage-specific styling
          if (geocoder.currentDropdown) {
            geocoder.currentDropdown.classList.add('homepage-address-dropdown');
          }
        }
      } else {
        // Retry after a short delay if FreshpaintGeocoder isn't ready yet
        setTimeout(initAddressAutocomplete, 100);
      }
    };

    initAddressAutocomplete();

    const address = $('.form-item-address');
    if (!address.find('.clear-button').length) {
      const clearButton = $('<button type="button" class="clear-button hidden" aria-label="Clear address field"></button>');
      address.append(clearButton);

      clearButton.on('click', function () {
        address.find('input').val('');
        clearButton.addClass('hidden');
        address.find('input').focus();
      });

      address.find('input').on('input', function () {
        if (this.value.length) {
          clearButton.removeClass('hidden');
        } else {
          clearButton.addClass('hidden');
        }
      });
    }

    const keywordWrapper = $('.summit-homepage-search-form .form-item-keywords');
    const keyword = keywordWrapper.find('input');

    const filterHighlightMatch = (needle) => {
      if (!needle) { return ''; }
      const ignoreKeyords = ['dr', 'dr.' , 'Doctor'];
      let keywords = needle.split(' ').map(keyword => keyword.trim());
      let ignoreKeyordsLowerCase = ignoreKeyords.map(w => w.toLowerCase());
      let filteredKeywords = keywords.filter(keyword => !ignoreKeyordsLowerCase.includes(keyword.toLowerCase()));
      return filteredKeywords.join(' ');
    };

    const hightlightMatch = (needle, haystack) => {
      if (!needle) { return ''; }
      let needleFiltered = filterHighlightMatch(needle);
      const regex = new RegExp(`(${needleFiltered})`, 'gi');
      return haystack.replace(regex, '<b>$1</b>');
    };

    const buildDefaultItem = (item, searchTerm, highlight = false) => {
      let label = item.label;
      if (highlight && searchTerm) {
        label = hightlightMatch(searchTerm, label);
      }
      const resultDiv = $('<div>').addClass('result-autosuggest');
      const resultTextDiv = $('<div>').addClass('result-text').append(label);
      resultDiv.append(resultTextDiv);
      return resultDiv;
    };

    const buildProviderItem = (item, searchTerm) => {
      let label = hightlightMatch(searchTerm, item.label);
      let specialty = hightlightMatch(searchTerm, item.specialty);
      const textDiv = $('<div>').addClass('result-text').append(label);
      const specialtyDiv = $('<div>').addClass('result-specialty').append(specialty);
      const providerContent = $('<div>').addClass('provider-content').append(textDiv, specialtyDiv);
      const providerImage = $('<img>').attr('src', item.image).addClass('provider-image');
      const providerDiv = $('<div>').addClass('provider-inner').append(providerImage, providerContent);
      const resultDiv = $('<div>').addClass('result-autosuggest', 'provider').append(providerDiv);
      return resultDiv;
    };

    let modal = $('#homepage-search-modal');
    const homepageSearchForm = $('.summit-homepage-search-form');
    const isMobileMediaQuery = window.matchMedia('(max-width: 1199px)');
    const body = $('body');

    $.widget("custom.summitAutocomplete", $.ui.autocomplete, {
      _create: function () {
        this._super();
        this.widget().menu("option", "items", "> :not(.ui-autocomplete-category)");
      },
      _renderItem: function (ul, item) {
        let searchTerm = false;
        if (this.term) {
          searchTerm = this.term;
        }
        let selectedItem = localStorage.getItem('selectedItem');
        const returnItem = $('<li>').attr('data-value', item.value);
        if (selectedItem) {
          if (item.label.toLowerCase() === selectedItem.toLowerCase()) {
            returnItem.addClass('current-search');
          }
        }
        switch (item.category) {
          case true:
            break;
          case 'common-suggestions':
            returnItem.append(buildDefaultItem(item, searchTerm));
            break;
          case 'doctors':
            returnItem.append(buildProviderItem(item, searchTerm, true));
            break;
          case 'specialties':
            returnItem.append(buildDefaultItem(item, searchTerm, true));
        }
        return returnItem.appendTo(ul);
      },
      _renderMenu: function (ul, items) {
        let that = this;
        $.each(items, function (index, item) {
          if (item.category === true) {
            ul.append('<li class="ui-autocomplete-category" ><div class="result-category">' + item.label + '</div></li>');
          } else {
            that._renderItemData(ul, item);
          }
        });
        $(ul).addClass('summit-autocomplete').addClass('summit-autocomplete--show').css('opacity', '1');
        $('body').addClass('autocomplete-initialized').addClass('autocomplete--is-showing');

        adjustAutocomplete();




      },
    });

    const processSuggestionResponse = (data) => {
      const returnArray = [];
      if (data['common-suggestions']) {
        if (data['common-suggestions']['suggestions'].length > 0) {
          returnArray.push({
            label: 'Common Searches',
            value: 'common-suggestions',
            category: true
          });
          data['common-suggestions']['suggestions'].forEach((item) => {
            item['category'] = 'common-suggestions';
            returnArray.push({
              label: item,
              value: item,
              category: 'common-suggestions'
            });
          });
        }
      }
      if (data['doctors']) {
        if (data['doctors']['suggestions'].length > 0) {
          returnArray.push({
            label: 'Providers',
            value: 'providers',
            category: true
          });
          data['doctors']['suggestions'].forEach((item) => {
            item['category'] = 'doctors';
            item['label'] = item.title;
            item.value = item.title;
            returnArray.push(item);
          });
        }
      }
      if (data['specialties']) {
        if (data['specialties']['suggestions'].length > 0) {
          returnArray.push({
            label: 'Specialties',
            value: 'specialties',
            category: true
          });
          data['specialties']['suggestions'].forEach((item) => {
            item['category'] = 'specialties';
            returnArray.push({
              label: item,
              value: item,
              category: 'specialties'
            });
          });
        }
      }
      return returnArray;
    };

    keyword.summitAutocomplete({
      minLength: 0,
      position: {
        my: "left+0 top+16",
      },
      focus: function () {
        return false;
      },
      source: function (request, response) {
        const keyword = request.term;
        const url = '/home-search/suggest/' + keyword;

        $.ajax({
          url: url,
          data: {
            term: request.term
          },
          success: function (data) {
            response(processSuggestionResponse(data));

            if (keyword.length >= 3) {
              localStorage.setItem('recentSearch', keyword);
              console.log('Saved Search: ' , localStorage.getItem('recentSearch'));
            } else {
              console.log('Search not saved');
            }

          },
        });
      },
      select: function (event, ui) {
        let itemLabel = ui.item.label;
        keyword.val(itemLabel);
        localStorage.setItem('selectedItem', itemLabel);
        $('.summit-homepage-search-form .form-item-keywords .clear-button').removeClass('hidden');
        // keyword[0].dispatchEvent(new InputEvent('input'));
        skipManualTriggerSearch = true;
        $('.summit-autocomplete').removeClass('summit-autocomplete--show').css('display','none');
        $('body').removeClass('autocomplete--is-showing');

        if (ui.item.category == "doctors") {
          var form = $(this).closest('form');
          form.submit();

          const recentSearch = ui.item.label;
          localStorage.setItem('recentSearch', recentSearch); // Store the most recent search

        } else {
          if ($('body').hasClass('modal-open')) {

            $('body').removeClass('modal-open');
            $('body').removeClass('modal-keyword');
            $('body').removeClass('autocomplete--is-showing');

            $('.summit-autocomplete').removeClass('summit-autocomplete--show');
            $('.summit-homepage-search-form').insertAfter('.homepage-hero__header');
            keyword.focus();
          }
        }
        event.preventDefault();
      }
    });

    keyword.off('keyup').on('keyup', function () {

      console.log('keyword keyup');

      var keywordLength = $(this).val().length;
      var keywordDescending = keywordLength < keywordLengthLast;

      if (keywordDescending) {
        if (keywordLength === 0) {

          localStorage.setItem('recentSearch', '');
          console.log('Saved Search deleted');
          triggerSearch($(this), 'descendingNoKeyword');

        } else if (keywordLength < 3) {
          // This is where the plugin hides it, so we override.
          triggerSearch($(this), 'descendingHasKeyword');
          $('.summit-autocomplete').addClass('summit-autocomplete--show');
          $('body').addClass('autocomplete--is-showing');
        }
      }

      keywordLengthLast = keywordLength;
    });

    keyword.off('focus').on('focus', function (event) {
      debugPlease && console.log('focus');

      event.stopPropagation();

      let autocompleteIsNotShowing = $('.summit-autocomplete--show').length === 0;

      if (debugPlease) {
        console.group('keyword focus()');
        console.log('skipManualTriggerSearch: ' , skipManualTriggerSearch);
        console.log('autocompleteIsNotShowing: ' , autocompleteIsNotShowing);
        console.groupEnd;
      }

      if (skipManualTriggerSearch) {
        return;
      }

      if (autocompleteIsNotShowing) {
        triggerSearch($(this), 'FocusOnInput');
      }

    });

    if (!keywordWrapper.find('.clear-button').length) {
      const clearButton = $('<button type="button" class="clear-button hidden" aria-label="Clear keyword field"></button>');
      keywordWrapper.append(clearButton);

      clearButton.on('click', function () {
        console.log('Clear');
        resetAutocompleteMenu(keyword);
        keyword.val('');
        localStorage.setItem('recentSearch', '')
        localStorage.setItem('selectedItem', '');
        clearButton.addClass('hidden');
        // skipManualTriggerSearch = true;
        keyword.focus();
      });

      keyword.on('input', function () {
        if (this.value.length) {
          clearButton.removeClass('hidden');
        } else {
          clearButton.addClass('hidden');
        }
      });
    }

    // Check if the div with id "homepage-search-modal" exists
    if ($('#homepage-search-modal').length === 0) {
      const modalDiv = $('<div>').attr('id', 'homepage-search-modal');
      const modalRow = $('<div>').addClass('modal-row');
      const modalCancelButton = $('<button>').addClass('modal-cancel-button').text('Cancel');
      modalCancelButton.on('click', function () {
        $('body').removeClass('modal-open');
        $('body').removeClass('modal-keyword');
        $('body').removeClass('autocomplete--is-showing');
        $('.summit-autocomplete').removeClass('summit-autocomplete--show');
        $('.summit-homepage-search-form').insertAfter('.homepage-hero__header');
        keyword.focus();
      });
      modalRow.append(modalCancelButton);
      modalDiv.append(modalRow);
      $('body').append(modalDiv);
      // Account for variable hoisting.
      modal = $('#homepage-search-modal');
    }

    // add an event listener to [name="keywords"] input field
    keyword.off('click').on('click', function () {

      debugPlease && console.log('Input clicked');

      if (isMobileMediaQuery.matches) {
        if (!body.hasClass('modal-open')) {

          modal.append(homepageSearchForm);
          body.addClass('modal-open').addClass('modal-keyword');
          if (document.activeElement !== keyword[0]) {
            keyword.focus();
          }
          triggerSearch(keyword);
        }
      }
    });

    $(window).on('resize scroll', function() {
      if ($('body').hasClass('autocomplete-initialized')) {
        adjustAutocompleteHeight();
        adjustAutocompletePosition();
      }
    });

    $(document).on('click', checkClickOutside);

  }
}

DrupalBehavior.register('summit_search', 'home-page-search', HomePageSearch);
